import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-treatment-guideline',
	templateUrl: './modal-treatment-guideline.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class ModalTreatmentGuidelineComponent implements OnInit {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private dialogRef = inject(MatDialogRef<ModalTreatmentGuidelineComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.options = this.vm.options || {};
		this.vm.text = this.angularHelperService.trustAsHtml(this.vm.options.text);
		this.vm.btnText = this.vm.options.btnText || this.angularFilterHelperService.translate('Common.Ok');
		
		this.vm.cancel = this.cancel;
		this.vm.submit = this.submit;
	}
	
	cancel() {
		this.dialogRef.close();
	}
	
	submit() {
		if (typeof this.vm.onClick === 'function') this.vm.onClick();
		this.dialogRef.close();
	}
	
}